import { AutocompleteWebsiteItem } from "@similarweb/ui-components";

import { createWebsiteUrl } from "app/pages/activation/components/HomeSearch/helpers/createWebsiteUrl";
import { redirectToUrl } from "app/pages/activation/components/HomeSearch/helpers/redirectToUrl";
import type { OnSearchItemClick } from "app/pages/activation/components/HomeSearch/types";
import { fetchWebsitesFaviconsQuery } from "app/services/sitesService/queries/sitesQueries";

const createDefaultWebsiteItem = ([domain, iconUrl]: [string, string], onClick?: OnSearchItemClick) => {
    const url = createWebsiteUrl(domain);

    const onItemClick = () => {
        onClick?.(domain, "popular");

        redirectToUrl(url);
    };

    return (
        <AutocompleteWebsiteItem
            mainSite={{ domain, iconUrl }}
            onItemClick={onItemClick}
        />
    );
};

export const createDefaultWebsiteItems = async (domains: string[], onClick?: OnSearchItemClick) => {
    const websitesWithFavicons = await fetchWebsitesFaviconsQuery(domains);

    return Object.entries(websitesWithFavicons).map((item) => createDefaultWebsiteItem(item, onClick));
};
